import React from 'react';

import ActionButton from './ActionButton';

import { PermissionList, RoleList } from 'crm/helpers/Permissions';

type Props = {
    params: { key: string; value: string | number | null }[];
    icon?: string;
    roles?: RoleList;
    permissions?: PermissionList;
    title?: string;
    className?: string;
};

/**
 * Takes in params and update the url with them, if param value is null it will be removed.
 * Can either be provided with a title or icon to display. Takes in roles and permissions.
 */
export default function LinkWithParams({
    params,
    icon,
    roles = [],
    permissions = [],
    title = '',
    className = '',
}: Props) {
    const searchParams = new URLSearchParams(window.location.search);
    params.forEach((param) => {
        if (param.value) {
            searchParams.set(param.key, param.value as string);
        } else {
            searchParams.delete(param.key);
        }
    });

    const displayContent = title ? <span>{title}</span> : icon && <i className={`fa ${icon}`} />;

    return (
        <ActionButton
            url={`?${searchParams.toString()}`}
            title={displayContent}
            roles={roles}
            permissions={permissions}
            className={className}
        />
    );
}
